
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/print-terms-and-conditions",
      function () {
        return require("private-next-pages/print-terms-and-conditions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/print-terms-and-conditions"])
      });
    }
  